import React, { useEffect, useRef, useState } from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

//Assets
import wallet_wc from "../../assets/wallet_wc.svg";
import note_wc from "../../assets/note_wc.svg";
import { MOBILE } from "../../constants/breakpoints";

//Components
import Button from "../Button";

function Info({ switchToWallets }: { switchToWallets?: () => void }) {
  return (
    <>
      <MobileInfo switchToWallets={switchToWallets} />
      <DesktopInfo />
    </>
  );
}

function MobileInfo({ switchToWallets }: { switchToWallets?: () => void }) {
  const [scrollStatus, setscrollStatus] = useState("top");

  const scrollBlurFn = (e: any) => {
    //get scroll position in percentage
    const scrollPosition = (e.target as any).scrollTop;
    //get max scroll position
    const maxScroll =
      (e.target as any).scrollHeight - (e.target as any).clientHeight;
    if (scrollPosition < 2) {
      setscrollStatus("top");
    } else if (scrollPosition > maxScroll - 2) {
      setscrollStatus("bottom");
    } else {
      setscrollStatus("middle");
    }
  };

  return (
    <div>
      <span
        key={"scroll-con-wrapper"}
        css={css`
          height: 73%;
          position: relative;
          display: block;
          @media (min-width: ${MOBILE+1}px) {
            display: none;
          }
        `}
      >
        {scrollStatus !== "top" && <BlurShade pos="top" />}
        <span
          onScroll={scrollBlurFn}
          id="scroll-con"
          key={"scroll-con"}
          css={css`
            display: flex;
            flex-direction: column;
            gap: 16px;
            height: 100%;
            overflow-x: hidden;
            overflow-y: auto;
          `}
        >
          <InfoPane
            img={wallet_wc}
            title={"What is a Wallet?"}
            text={
              "Crypto wallets store your private keys - the passwords that give you access to your cryptocurrencies – allowing you to send and receive cryptocurrencies like Bitcoin and Ethereum. They come in many forms, from hardware wallets like Ledger (which looks like a USB stick) to mobile apps and browser extensions like Metamask and Coinbase Wallet."
            }
          />
          <InfoPane
            img={note_wc}
            title={"Which Type of Wallet Should I Use?"}
            text={
              "We believe the core ethos of Web3 is the user should decide. Wallets can vary in complexity, convenience and security. This means you have the ability to choose more centralized custodial wallets to being self sovereign and managing everything on your on. We strive to provide as many options as possible to fit your specific needs."
            }
          />
        </span>
        {scrollStatus !== "bottom" && <BlurShade pos="bottom" />}
      </span>
      <span
        css={css`
          display: flex;
          width: 100%;
          justify-content: space-between;
          margin-top: 30px;

          @media (min-width: ${MOBILE+1}px) {
            display: none;
          }
        `}
      >
        <Button
          onClick={() => {
            if (switchToWallets) {
              switchToWallets();
            }
          }}
          width={"50%"}
          type="OUTLINE"
        >
          Back
        </Button>
        <Button
          onClick={() => {
            if (switchToWallets) {
              switchToWallets();
            }
          }}
          width={"50%"}
          type="YELLOW"
        >
          Connect
        </Button>
      </span>
    </div>
  );
}

function DesktopInfo() {
  return (
    <span
      css={css`
        height: 100%;
        position: relative;
        display: block;
        @media (max-width: ${MOBILE}px) {
          display: none;
        }
      `}
    >
      <span
        css={css`
          display: flex;
          flex-direction: column;
          gap: 16px;
          height: 100%;
          overflow-x: hidden;
          overflow-y: auto;
        `}
      >
        <InfoPane
          img={wallet_wc}
          title={"What is a Wallet?"}
          text={
            "Crypto wallets store your private keys - the passwords that give you access to your cryptocurrencies – allowing you to send and receive cryptocurrencies like Bitcoin and Ethereum. They come in many forms, from hardware wallets like Ledger (which looks like a USB stick) to mobile apps and browser extensions like Metamask and Coinbase Wallet."
          }
        />
        <InfoPane
          img={note_wc}
          title={"Which Type of Wallet Should I Use?"}
          text={
            "We believe the core ethos of Web3 is the user should decide. Wallets can vary in complexity, convenience and security. This means you have the ability to choose more centralized custodial wallets to being self sovereign and managing everything on your on. We strive to provide as many options as possible to fit your specific needs."
          }
        />
      </span>
    </span>
  );
}

const InfoPane = ({
  img,
  title,
  text,
}: {
  img: string;
  title: string;
  text: string;
}) => {
  return (
    <div
      css={css`
        display: flex;
      `}
    >
      <img
        css={css`
          margin-bottom: auto;
          margin-right: 30px;
          @media (max-width: ${MOBILE}px) {
            margin-right: 15px;
          }
        `}
        src={img}
        alt=""
      />
      <span>
        <h2
          css={css`
            margin: 0;
            font-weight: 700;
            font-size: 16px;
            line-height: 150%;

            @media (max-width: ${MOBILE}px) {
              font-size: 14px;
            }
          `}
        >
          {title}
        </h2>
        <p
          css={css`
            line-height: 140%;
            font-weight: 400;
            font-size: 14px;
            margin: 0;
            margin-top: 8px;
            width: 390px;
            @media (max-width: ${MOBILE}px) {
              width: 100%;
            }
          `}
        >
          {text}
        </p>
      </span>
    </div>
  );
};

const BlurShade = ({ pos }: { pos: "top" | "bottom" }) => {
  return (
    <span
      css={css`
        display: flex;
        display: flex;
        min-height: 30px;
        width: 100%;
        background: linear-gradient(
          ${pos === "top" ? "180deg" : "0deg"},
          #ffffff 0%,
          rgba(255, 255, 255, 0.7) 49.38%,
          rgba(255, 255, 255, 0) 100%
        );
        position: absolute;
        ${pos === "top" ? "top: 0;" : "bottom: 0;"}
      `}
      id={"blur-" + pos}
    ></span>
  );
};

export default Info;
